import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-454b944e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/store.svg" }, null, -1))
const _hoisted_3 = { class: "bold f12" }
const _hoisted_4 = {
  class: "flex col align-center grow p12 justify-center g24",
  style: {"text-align":"center","flex":"1 0 0"}
}
const _hoisted_5 = ["aria-valuenow"]
const _hoisted_6 = { class: "flex col align-center g0" }
const _hoisted_7 = { class: "bold f20" }
const _hoisted_8 = { class: "text-muted f12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Meilleurs établissements " }, {
    header: _withCtx(() => []),
    body: _withCtx(() => [
      _createElementVNode("div", {
        class: "audit-grid p12 grow",
        onWheel: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onWheel && _ctx.onWheel(...args)), ["prevent"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topStores, (store) => {
          return (_openBlock(), _createBlock(_component_Card, null, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("span", _hoisted_3, _toDisplayString(store.name), 1)
              ])
            ]),
            body: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "circular-progress",
                  "aria-valuenow": store.score / 2,
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                  style: _normalizeStyle('--value:' + store.score / 2)
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(store.score), 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Lang.getI18N("out-of-100")), 1)
                  ])
                ], 12, _hoisted_5)
              ])
            ]),
            _: 2
          }, 1024))
        }), 256))
      ], 32)
    ]),
    _: 1
  }))
}